import { Chip, css, styled } from '@lux/ds';

export const StyledNavItem = styled('div', { shouldForwardProp: prop => prop !== '$selected' })<{
  $selected?: boolean;
}>(
  ({ theme, $selected }) => css`
    position: relative;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    gap: ${theme.space.m};
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px;

    ${$selected &&
    css`
      :before {
        content: '';
        background-color: ${theme.palette.primary.main};
        width: 4px;
        height: 100%;
        position: absolute;
        top: 0;
        left: -1px;
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
      }

      > button {
        color: ${theme.palette.primary.main};
      }

      g {
        fill: ${theme.palette.primary.main};
      }
    `}

    .expanded-menu-items {
      display: flex;
      flex-direction: column;
      gap: ${theme.space.s};
    }
  `,
);

interface INavButtonProps {
  active?: boolean;
  open: boolean;
}

export const NavButton = styled('div', {
  shouldForwardProp: prop => !['active', 'open'].includes(prop as string),
})<INavButtonProps>(
  ({ theme, active, open }) => css`
    border-radius: 4px;
    width: 40px;
    height: 40px;
    color: ${theme.palette.primary.shade[40]};
    display: flex;
    justify-content: flex-start;
    align-self: center;
    gap: ${theme.space.s};
    overflow: hidden;
    padding: ${theme.space.xs};
    box-sizing: border-box;
    cursor: pointer;
    transition: width 0.5s;

    g {
      fill: ${theme.palette.primary.shade[40]};
    }

    :hover {
      background-color: ${theme.palette.primary.shade[90]};
    }

    ${active &&
    css`
      background-color: ${theme.palette.primary.shade[90]};
    `}

    ${open &&
    css`
      width: 270px;
    `}
  `,
);

export const NavTag = styled(Chip)(
  ({ theme }) => css`
    background-color: ${theme.palette.purdie.light};
    color: ${theme.palette.purdie.dark};
    font-size: 12px;
  `,
);

export const NavIconWrapper = styled('div', { shouldForwardProp: prop => prop !== '$isNew' })<{
  $isNew?: boolean;
}>(
  ({ $isNew, theme }) => css`
    position: relative;

    ${$isNew
      ? css`
          &::after {
            background-color: ${theme.palette.purdie.main};
            border-radius: 50%;
            content: '';
            height: ${theme.space.xs};
            position: absolute;
            right: -4px;
            top: -4px;
            width: ${theme.space.xs};
          }
        `
      : ''}
  `,
);
